import { apiClient } from '../client';

export interface SurpriseUser {
  _id: string;
  name?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
}

export interface SurpriseRoll {
  _id: string;
  user_id: string | SurpriseUser;
  selected_user_id: string | SurpriseUser;
  campus_id: string;
  status: 'started' | 'completed' | 'expired';
  roll_started_at: string;
  roll_completed_at?: string;
  expired_at?: string;
  duration?: number;
  createdAt: string;
  updatedAt: string;
}

export interface SurpriseOverview {
  totalRolls: number;
  completedRolls: number;
  expiredRolls: number;
  todayRolls: number;
  activeUsers: number;
  completionRate: string;
  avgDurationSeconds: number;
  dailyLimit: number;
}

export interface TopUser {
  userId: string;
  rollCount: number;
  completedCount: number;
  userName: string;
  userEmail: string;
}

export interface UserSurpriseStats {
  user: {
    _id: string;
    name: string;
    email: string;
    reshufflesLeft: number;
    todayUsed: number;
    dailyLimit: number;
    lastReshuffleDate?: string;
    totalReshufflesUsed: number;
  };
  statistics: {
    totalRolls: number;
    completedRolls: number;
    expiredRolls: number;
    completionRate: string;
  };
  rollHistory: SurpriseRoll[];
}

export const surpriseAPI = {
  // Get admin statistics
  getAdminStats: async (params?: {
    campus_id?: string;
    startDate?: string;
    endDate?: string;
  }) => {
    const response = await apiClient.get('/api/surprise/admin/stats', { params });
    return response.data.data as {
      overview: SurpriseOverview;
      topUsers: TopUser[];
      recentRolls: SurpriseRoll[];
    };
  },

  // Get user-specific statistics
  getUserStats: async (userId: string) => {
    const response = await apiClient.get(`/api/surprise/admin/user/${userId}`);
    return response.data.data as UserSurpriseStats;
  },
};